/**
 * fetch com TEMPO LIMITE para LEITURA (revisão 360: GET sem timeout deixava a tela "carregando"
 * para sempre quando a API ou a rede travavam).
 *
 * - GET/HEAD: desiste depois de 15 s esperando a resposta. A desistência rejeita como uma falha de
 *   rede — cada cliente já trata isso como "sem conexão" (estado de erro explícito, nunca "0").
 * - Escrita (POST/PUT/…): SEM limite aqui. Cortar uma escrita no meio deixa o resultado incerto;
 *   quem escreve já tem o próprio controle (ex.: registrar venda).
 * - O limite vale até chegar a resposta; ler o corpo não é cortado (o corpo lido pela metade
 *   quebraria fora do try de quem chama).
 */
export const LIMITE_DA_LEITURA_MS = 15_000;

export async function buscar(
  caminho: string,
  init: RequestInit = {},
  limiteMs: number = LIMITE_DA_LEITURA_MS,
): Promise<Response> {
  const metodo = (init.method ?? 'GET').toUpperCase();
  if ((metodo !== 'GET' && metodo !== 'HEAD') || init.signal) return fetch(caminho, init);
  const controle = new AbortController();
  const relogio = setTimeout(() => {
    controle.abort();
  }, limiteMs);
  try {
    return await fetch(caminho, { ...init, signal: controle.signal });
  } finally {
    clearTimeout(relogio);
  }
}
